module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg17.2332a70e.jpg";